import React from 'react';
import { Icon, Feed, Label, Image } from 'semantic-ui-react';
import moment from 'moment';
import _ from 'lodash';

const atMentionRegex = /(@\w+\b)/g;

const GridLayout = ({ items }) => (
  <Feed style={{ maxHeight: '600px', overflowY: 'scroll' }}>
    {
      _.map(items, item => {
        const post = item.postData;
        // if (!post || !item.isAd) return null;

        const relativeTime = post && moment(post.date * 1000).fromNow();
        const atMatches = post && _.uniqBy(post.caption.match(atMentionRegex));

        if (!item.isAd) return null;

        return (
          <Feed.Event style={{ border: '1px solid #eee', margin: '5px 0px', padding: '10px' }}>
            <Feed.Label>
              <Image src={post && post.display_src} />
            </Feed.Label>
            <Feed.Content>
              <Feed.Summary>
                <Feed.User>{ item.handle }</Feed.User> added a new sponsored post on INSTAGRAM!
                <Feed.Date>{relativeTime}</Feed.Date>
                <p>
                  <a
                    ref="noreferrer noopener"
                    target="_blank"
                    href={`https://www.instagram.com/p/${item.instagramCode}/`}
                  >
                    {`https://www.instagram.com/p/${item.instagramCode}/`}
                  </a>
                </p>
              </Feed.Summary>
              <Feed.Extra text>
                <p>{ item.isAd && <Icon name="money" color="pink" size="large" /> }</p>
                { post && _.truncate(post.caption, { length: 200, separator: ' ' }) }
              </Feed.Extra>
              <Feed.Meta>
                <Feed.Like>
                  <Icon name='heart' />
                  { post && post.likes.count}
                </Feed.Like>
                <Feed.Like>
                  <Icon name='comment' />
                  { post && post.comments.count}
                </Feed.Like>
              </Feed.Meta>
              <Feed.Extra text>
                {
                  atMatches &&
                  _.map(atMatches, handle => (
                    <Label color="pink" basic content={handle} />
                  ))
                }
              </Feed.Extra>
            </Feed.Content>
          </Feed.Event>
        );
      })
    }
  </Feed>
);

export default GridLayout;



/** WEBPACK FOOTER **
 ** ./src/components/influencer-ad-posts/grid-layout.js
 **/